export const OTHERS = "Other";
export const DISASTER_CALAM = "Disaster and Calamities";
export const INFRA = "Infrastructure";
export const SCIENTIFIC = "Scientific Research and Education";
export const AGRI = "Agriculture/Forestry";
export const CLIMATE = "Climate/Atmospheric";
export const WATER = "Water Resources";
export const ENV = "Environmental Assessment";
